import { useState as i, useEffect as l } from "react";
import { BroadcastChannel as c } from "broadcast-channel";
import { SIRONA_BROADCAST_CHANNEL as u } from "../constants/crossTabEvents.js";
import { emitter as m } from "../utils/emitter.js";
function C(e, r) {
  const [o] = i(
    new c(u)
  );
  l(() => {
    const n = ({
      namespace: t,
      payload: s
    }) => {
      e === t && r({ source: "remote", payload: s });
    }, f = (t) => {
      t != null && r({ source: "local", payload: t });
    };
    return o.addEventListener("message", n), m.on(e, f), () => {
      o.removeEventListener("message", n), m.off(e, f);
    };
  }, [e, r, o]);
}
export {
  C as useCrossTabEventsListener
};
//# sourceMappingURL=useCrossTabEventsListener.js.map
